import type { IconData } from '@stacksjs/iconify-core'

export const laptop: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 41c-9.62 0-15-.41-17.757-.734c-1.603-.19-2.75-1.264-2.923-2.87a61 61 0 0 1-.197-2.297A1.973 1.973 0 0 1 5.1 33h11.697c.702 0 1.323.455 1.534 1.125c.21.67.831 1.125 1.534 1.125h8.27c.701 0 1.322-.455 1.533-1.125A1.61 1.61 0 0 1 31.202 33h11.696c1.143 0 2.057.959 1.979 2.1a61 61 0 0 1-.197 2.297c-.173 1.605-1.32 2.68-2.924 2.869C39.002 40.59 33.62 41 24 41\"/><path d=\"M5.314 33C5.142 30.792 5 27.58 5 23c0-5.89.235-9.518.466-11.658c.189-1.755 1.402-3.084 3.141-3.383C11.194 7.513 15.927 7 24 7s12.806.513 15.393.959c1.74.299 2.952 1.628 3.141 3.383c.23 2.14.466 5.767.466 11.658c0 4.58-.142 7.792-.314 10\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default laptop
